<template>
  <div id="Home" class="fullpage">
    <full-page :options="fullpageOptions">
      <NewWelcome />
      <NewQuienesSomos />
      <NewProductos />
      <Desarrollo />
<!--      <Contacto />-->
      <Footer />
    </full-page>
    <!-- Navbar is FIXED to the page -->
    <Navbar :activeSection="activeSection" />
  </div>
</template>

<script>
import NewWelcome from "../components/nuevaPagina/Welcome"
import NewQuienesSomos from "../components/nuevaPagina/QuienesSomos"
import Navbar from "../components/Navbar"
import NewProductos from "../components/nuevaPagina/Productos"
// import Contacto from "../components/nuevaPagina/Contacto"
import Desarrollo from "../components/nuevaPagina/Desarrollo"
import Footer from "../components/nuevaPagina/Footer"

export default {
  components: {
    NewWelcome,
    NewQuienesSomos,
    NewProductos,
    Desarrollo,
    // Contacto,
    Footer,
    Navbar
  },
  data() {
    return {
      fullpageOptions: {
        licenseKey: "59FE94F0-B4524309-81416A43-DB0319DC",
        sectionSelector: ".fullpage-section",
        afterLoad: this.changeSlide,
        scrollBar: false,
        fitToSection: false,
        anchors: [
          "section-new-welcome",
          "section-quienes-somos",
          "section-productos",
          "section-dyp",
          "section-contacto",
          "footer"
        ]
      },
      activeSection: 0
    }
  },
  methods: {
    changeSlide(origin, destination) {
      this.activeSection = destination.index
    }
  }
}
</script>

<style>
.fullpage {
  width: 100vw;
  height: 100vh;
}
</style>
